/**
 * @file Defines the {@link DEFAULT_PAYOUT_COLOURS} constnat
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Colour config for payout section
  * @type {object}
  * @constant
  * @default
  * @property {string} amount  - Payout amount default colour
  * @property {string} matched - Payout number matched default colour
  * @property {string} text    - Payout text default colour
  */
 const DEFAULT_PAYOUT_COLOURS = {

    amount:  '#BABABA', 
    matched: '#FFF',
    text:    '#FFF'

 }

 export { DEFAULT_PAYOUT_COLOURS }